"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBandaidOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.405 3.642l8.939 8.889c1.767 1.768 2.475 5.303 0 7.778-2.475 2.475-6.046 1.803-7.778 0L3.627 11.42c-1.766-1.766-2.473-5.3.003-7.776 2.475-2.475 6.01-1.768 7.776-.002h-.001zM4.988 5.113c-1.414 1.414-1.285 3.55.207 5.041.025.025 4.937-4.957 4.937-4.957C8.65 3.715 6.53 3.572 5.115 4.986l-.127.127zm8.691 13.528c1.376 1.376 3.718 1.786 5.133.372 1.414-1.414-1.256 1.256.158-.159 1.414-1.414 1.034-3.785-.342-5.161l-4.949 4.948zm-7.063-7.079l5.657 5.657 4.95-4.95-5.657-5.656-4.95 4.95v-.001zm5.657-1.414a1 1 0 11-1.415-1.414 1 1 0 011.415 1.414zM10.15 12.27a1 1 0 11-1.438-1.389 1 1 0 011.438 1.389zm4.95.708a1 1 0 11-1.414-1.415 1 1 0 011.414 1.415zm-2.121 2.12a1.002 1.002 0 01-1.656-.308 1 1 0 01.242-1.105 1 1 0 011.414 1.414v-.001z' }))); };
exports.default = SvgBandaidOutline;
//# sourceMappingURL=BandaidOutline.js.map